import { S as Swiper } from './swiper-core-PnKJBlxA.js';
import { N as Navigation } from './navigation-qS4ZoLN1.js';
import { A as A11y } from './a11y-Dw_0tDap.js';

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-swiper]');
    this.dataOptions = JSON.parse(this.swiperElement?.dataset?.options || '{}');
  }

  connectedCallback() {
    this.initSwiper();

    if (!this.dataset || !this.dataset.url) return;
    this.fetchProducts();
  }

  async fetchProducts() {
    try {
      const response = await fetch(this.dataset.url);
      const text = await response.text();

      const html = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('[data-recommended-products]').innerHTML;
      this.querySelector('[data-recommended-products]').innerHTML = html;

      this.swiperInstance.update();
    } catch (error) {
      console.error(error);
    }
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [A11y, Navigation],
      threshold: 10,
      loop: false,
      direction: `horizontal`,
      slidesPerView: 2,
      initialSlide: 1,
      centeredSlides: true,
      centerInsufficientSlides: true,
      spaceBetween: 16,
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 24, centeredSlides: false, initialSlide: 0 },
        1024: { slidesPerView: 4, spaceBetween: 24, centeredSlides: false, initialSlide: 0 },
      },
      ...this.dataOptions,
    });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
